import styled, {css} from 'styled-components';
import {Image} from './image';

/** Monochrome SVG <img> icons — colors follow --icon-filter-* tokens in tokens.css */
export const iconMuted = css`
  filter: var(--icon-filter-muted);
  opacity: var(--icon-opacity-muted);
  transition: filter 200ms ease, opacity 200ms ease;
`;

export const iconHover = css`
  filter: var(--icon-filter-hover);
  opacity: var(--icon-opacity-hover);
`;

export const iconActive = css`
  filter: var(--icon-filter-active);
  opacity: 1;
`;

export const MutedIcon = styled(Image)`
  && {
    ${iconMuted}
  }

  &&:hover {
    ${iconHover}
  }
`;

/** Monochrome PNG shape previews — theme-aware via --icon-filter-muted */
export const LayoutShapeIcon = styled.img`
  display: block;
  object-fit: contain;
  flex-shrink: 0;
  ${iconMuted}
`;
